import { render, staticRenderFns } from "./CouriersPage.vue?vue&type=template&id=16cebf64&scoped=true&"
import script from "./CouriersPage.vue?vue&type=script&lang=js&"
export * from "./CouriersPage.vue?vue&type=script&lang=js&"
import style0 from "./CouriersPage.vue?vue&type=style&index=0&id=16cebf64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cebf64",
  null
  
)

export default component.exports